<button class="w-24 h-12 relative" [disabled]="disabled" (click)="onClick()">
  <div
    class="absolute top-0 right-0 bottom-0 left-0 bg-white"
    [style]="{ left: this.progress + '%' }"></div>
  <div
    class="absolute top-0 right-0 bottom-0 left-0 flex items-center justify-center z-10">
    <i [attr.class]="icon" style="font-size: 2rem"></i>
  </div>
</button>
